import { RFP_COUNTRY_LEGACY_DEFAULT } from "./rfpUploadFields";
export const CLASSES = [
  "Technical",
  "Sizing",
  "Implementation",
  "Support",
  "Training",
  "Administrative",
  "Commercial",
  "Partner",
  "Non-relevant",
];

export const CLASS_LABELS = {
  Technical: "Technical",
  Sizing: "Sizing",
  Implementation: "Implementation",
  Support: "Support",
  Training: "Training",
  Administrative: "Administrative",
  Commercial: "Commercial",
  Partner: "Partner",
  "Non-relevant": "Non-relevant",
};

export const LLM_CLASSES = CLASSES.filter((c) => c !== "Partner");

export const PRODUCT_CHIP_STYLES = {
  Alteon: "border-blue-300 bg-blue-50 text-blue-900 dark:border-blue-800 dark:bg-blue-950/50 dark:text-blue-200",
  "API Security": "border-violet-300 bg-violet-50 text-violet-900 dark:border-violet-800 dark:bg-violet-950/50 dark:text-violet-200",
  "Agentic AI": "border-fuchsia-300 bg-fuchsia-50 text-fuchsia-900 dark:border-fuchsia-800 dark:bg-fuchsia-950/50 dark:text-fuchsia-200",
  DefensePro: "border-orange-300 bg-orange-50 text-orange-900 dark:border-orange-800 dark:bg-orange-950/50 dark:text-orange-200",
  "Cloud DDoS": "border-amber-300 bg-amber-50 text-amber-900 dark:border-amber-800 dark:bg-amber-950/50 dark:text-amber-200",
  "Integrated WAF": "border-purple-300 bg-purple-50 text-purple-900 dark:border-purple-800 dark:bg-purple-950/50 dark:text-purple-200",
  "Cloud WAF": "border-indigo-300 bg-indigo-50 text-indigo-900 dark:border-indigo-800 dark:bg-indigo-950/50 dark:text-indigo-200",
  "Cyber Controller": "border-teal-300 bg-teal-50 text-teal-900 dark:border-teal-800 dark:bg-teal-950/50 dark:text-teal-200",
  "Gen Req": "border-yellow-300 bg-yellow-50 text-yellow-900 dark:border-yellow-700 dark:bg-yellow-950/50 dark:text-yellow-200",
  "Not relevant": "border-slate-300 bg-slate-100 text-slate-700 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-300",
};

export const ASSIGNABLE_PRODUCTS = Object.keys(PRODUCT_CHIP_STYLES).filter(
  (name) => name !== "Gen Req" && name !== "Not relevant"
);

export const CLASS_SELECT_STYLES = {
  Technical: "border-sky-300 bg-sky-50 text-sky-900 dark:border-sky-800 dark:bg-sky-950/50 dark:text-sky-200",
  Sizing: "border-cyan-300 bg-cyan-50 text-cyan-900 dark:border-cyan-800 dark:bg-cyan-950/50 dark:text-cyan-200",
  Administrative: "border-stone-300 bg-stone-100 text-stone-800 dark:border-stone-600 dark:bg-stone-900/50 dark:text-stone-200",
  Commercial: "border-amber-300 bg-amber-50 text-amber-900 dark:border-amber-800 dark:bg-amber-950/50 dark:text-amber-200",
  Support: "border-emerald-300 bg-emerald-50 text-emerald-900 dark:border-emerald-800 dark:bg-emerald-950/50 dark:text-emerald-200",
  Training: "border-lime-300 bg-lime-50 text-lime-900 dark:border-lime-800 dark:bg-lime-950/50 dark:text-lime-200",
  Implementation: "border-rose-300 bg-rose-50 text-rose-900 dark:border-rose-800 dark:bg-rose-950/50 dark:text-rose-200",
  Partner: "border-violet-300 bg-violet-50 text-violet-900 dark:border-violet-800 dark:bg-violet-950/50 dark:text-violet-200",
  "Non-relevant": "border-slate-300 bg-slate-100 text-slate-600 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-400",
  // legacy lowercase keys for older saved rows
  technical: "border-sky-300 bg-sky-50 text-sky-900 dark:border-sky-800 dark:bg-sky-950/50 dark:text-sky-200",
  sizing: "border-cyan-300 bg-cyan-50 text-cyan-900 dark:border-cyan-800 dark:bg-cyan-950/50 dark:text-cyan-200",
  administrative: "border-stone-300 bg-stone-100 text-stone-800 dark:border-stone-600 dark:bg-stone-900/50 dark:text-stone-200",
};

export const COACH_MARKS_KEY = "rfp_coach_marks_seen_v1";

export function classLabel(value) {
  return CLASS_LABELS[value] || CLASS_LABELS[normalizeGridClass(value)] || value || "Non-relevant";
}

export function productChipClass(product) {
  return PRODUCT_CHIP_STYLES[product] || PRODUCT_CHIP_STYLES["Not relevant"];
}

export function classSelectClass(reqClass) {
  const normalized = normalizeGridClass(reqClass);
  return CLASS_SELECT_STYLES[normalized] || CLASS_SELECT_STYLES["Non-relevant"];
}

export function normalizeGridClass(value) {
  const raw = (value || "").trim();
  if (!raw) return "Non-relevant";
  if (CLASS_LABELS[raw]) return raw;
  const lower = raw.toLowerCase();
  if (lower === "technical") return "Technical";
  if (lower === "sizing") return "Sizing";
  if (lower === "administrative") return "Administrative";
  if (lower === "implementation") return "Implementation";
  if (lower === "support") return "Support";
  if (lower === "training") return "Training";
  if (lower === "commercial") return "Commercial";
  if (lower === "partner") return "Partner";
  if (lower === "non-relevant" || lower === "non relevant") return "Non-relevant";
  return "Non-relevant";
}

export function isRequirementFromClass(value) {
  return normalizeGridClass(value) !== "Non-relevant";
}

const TOC_HEADING = /(?:^|\b)(?:\d+(?:\.\d+)*\.?\s*)?(índice|indice|sumário|sumario|table of contents|tabla de contenidos|tabla de contenido)\b/i;
const TOC_DOTTED_RUN = /\.{6,}/;
const TOC_TRAILING_REF = /(?:\d{1,4}(?:\.\d+){0,4}\.?|\d{1,4}\s+\d{1,3}(?:\.\d+){0,4}\.?)\s*$/;
const TOC_NUMBERED_PAGE = /^\d+\.?\s+\S.{4,80}\s+\d{1,4}\s*$/;
const TOC_OBLIGATION = /\b(debe|deben|deberá|deberán|deverá|deverão|shall|must|se requiere)\b/i;
const TOC_COVER_REPEAT =
  /(?:request for proposal|request for quotation|classificado como p[uú]blico|vers[aã]o:\s*\d|c[oó]digo:\s*rfp)/i;

function _tocText(row) {
  return (row?.text || "").replace(/\s+/g, " ").trim();
}

function _rowIsTocStamped(row) {
  return row?.is_toc === true || row?.is_toc === 1 || row?.is_toc === "1";
}

function _isOrphanTocNumber(row) {
  const t = _tocText(row);
  return /^\d{1,3}(?:\.\d{1,3}){0,4}\.?$/.test(t);
}

function _isDotOnlyLine(row) {
  return /^\.{6,}$/.test(_tocText(row));
}

function _isDotHeavyTocLine(t) {
  return t.replace(/[^.]/g, "").length >= 40;
}

function _tocWording(row) {
  const t = _tocText(row);
  if (!t) return false;
  if (TOC_OBLIGATION.test(t)) return false;
  if (_isDotOnlyLine(row)) return true;
  if (TOC_DOTTED_RUN.test(t)) {
    if (TOC_TRAILING_REF.test(t)) return true;
    if (t.length <= 200 || _isDotHeavyTocLine(t)) return true;
  }
  if (TOC_HEADING.test(t)) return true;
  if (TOC_NUMBERED_PAGE.test(t) && t.length <= 120) return true;
  return false;
}

/** True when a grid row is a table-of-contents / índice / sumário line (UI hide only). */
export function isTocGridRow(row) {
  if (_tocWording(row)) return true;
  const t = _tocText(row);
  if (
    _rowIsTocStamped(row) &&
    (_isOrphanTocNumber(row) || TOC_DOTTED_RUN.test(t) || _isDotOnlyLine(row))
  ) {
    return true;
  }
  return false;
}

export function isTocCoverRepeat(row) {
  const t = _tocText(row);
  if (!t || t.length > 400) return false;
  if (TOC_OBLIGATION.test(t)) return false;
  return TOC_COVER_REPEAT.test(t);
}

function _isBodyStartRow(row) {
  const t = _tocText(row);
  if (!t) return false;
  if (TOC_OBLIGATION.test(t) && !TOC_DOTTED_RUN.test(t)) return true;
  const page = Number(row?.pdf_page);
  if (page >= 7 && t.length >= 30 && !TOC_DOTTED_RUN.test(t) && !TOC_HEADING.test(t)) return true;
  if (t.length > 80 && !TOC_DOTTED_RUN.test(t) && !TOC_HEADING.test(t) && !_isOrphanTocNumber(row)) {
    return true;
  }
  return false;
}

function _shouldHideInLeadingRun(row) {
  const t = _tocText(row);
  if (_rowIsTocStamped(row) && !TOC_OBLIGATION.test(t)) return true;
  if (isTocGridRow(row)) return true;
  if (isTocCoverRepeat(row)) return true;
  if (_isOrphanTocNumber(row)) return true;
  if (_isDotOnlyLine(row)) return true;
  return false;
}

/** Ids of the leading sumário run, including short cover repeats inside it. */
const GRID_HIDE_SCOPES = new Set(["legal_admin", "other_tech", "general"]);

export function isExcludedFocusRow(row) {
  return GRID_HIDE_SCOPES.has((row?.focus_scope || "").trim());
}

export function excludedFocusRowIds(rows) {
  return new Set((rows || []).filter(isExcludedFocusRow).map((row) => row.id).filter(Boolean));
}

export function tocRowIdsToHide(rows) {
  const list = rows || [];
  const hide = new Set();
  let pastBody = false;

  for (let i = 0; i < list.length; i++) {
    const row = list[i];
    if (isTocGridRow(row)) {
      if (row?.id) hide.add(row.id);
      continue;
    }
    if (pastBody) continue;

    if (_isBodyStartRow(row)) {
      pastBody = true;
      continue;
    }

    if (_shouldHideInLeadingRun(row)) {
      if (row?.id) hide.add(row.id);
      continue;
    }

    pastBody = true;
  }

  for (let i = 0; i < list.length; i++) {
    if (!_isOrphanTocNumber(list[i]) || !list[i]?.id) continue;
    if (hide.has(list[i].id)) continue;
    const prev = i > 0 ? list[i - 1] : null;
    const next = i + 1 < list.length ? list[i + 1] : null;
    if ((prev && hide.has(prev.id)) || (next && hide.has(next.id))) {
      hide.add(list[i].id);
    }
  }
  return hide;
}

export function formatWhen(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString(undefined, { dateStyle: "short", timeStyle: "short" });
  } catch {
    return iso;
  }
}

/** Display customer for library cards and review header (backward compatible). */
export function displayCustomer(job) {
  const name = (job?.customer_name || "").trim();
  if (name) return name;
  const fn = (job?.filename || "").trim();
  if (fn) return fn.replace(/\.(pdf|docx)$/i, "");
  return "Unknown customer";
}

/** Display owner SE with fallback for legacy jobs. */
export function displayOwnerSe(job) {
  return (job?.owner_se || "").trim() || "Unassigned SE";
}

/** Display country; legacy jobs without country are CALA. */
export function displayCountry(job) {
  const country = (job?.country || "").trim();
  return country || RFP_COUNTRY_LEGACY_DEFAULT;
}

/** Strip .pdf / .docx / Excel extensions from an uploaded filename for export stems. */
export function sourceBasename(filename, fallbackId) {
  const fn = (filename || `${fallbackId || "rfp"}.pdf`).trim();
  return fn.replace(/\.(pdf|docx|xlsx|xls)$/i, "");
}

export function isExcelSource(jobOrFormat) {
  const format = typeof jobOrFormat === "string" ? jobOrFormat : jobOrFormat?.source_format;
  return ["xlsx", "xls"].includes(String(format || "").toLowerCase());
}

export function formatExcelSourceLocation(loc) {
  if (!loc || !loc.sheet) return "";
  const start = Number(loc.row_start);
  const end = Number(loc.row_end || loc.row_start);
  if (!Number.isFinite(start)) return loc.sheet;
  const rows = !Number.isFinite(end) || end === start ? `Row ${start}` : `Rows ${start}–${end}`;
  return `${loc.sheet} — ${rows}`;
}

export function formatExcelSourceRanges(ranges) {
  const items = (ranges || []).map(formatExcelSourceLocation).filter(Boolean);
  return items.join("; ") || "—";
}

/** Display optional RFP document version. */
export function displayRfpVersion(job) {
  return (job?.rfp_version || "").trim();
}

/** Format stored page ranges for UI (e.g. "90-100, 405-600"). */
export function displayPageRanges(job) {
  if (isExcelSource(job)) {
    if (job?.selected_sheets === "*") return "All worksheets";
    if (Array.isArray(job?.selected_sheets) && job.selected_sheets.length) {
      return job.selected_sheets.join(", ");
    }
    return job?.status === "awaiting_sheet_selection" ? "Select worksheets" : "";
  }
  const raw = (job?.page_ranges_raw || job?.page_ranges_applied || "").trim();
  if (raw) return raw;
  const ranges = job?.page_ranges;
  if (!Array.isArray(ranges) || !ranges.length) return "";
  return ranges
    .map((item) => {
      const start = Number(item?.[0]);
      const end = Number(item?.[1]);
      if (!Number.isFinite(start) || !Number.isFinite(end)) return "";
      return start === end ? String(start) : `${start}-${end}`;
    })
    .filter(Boolean)
    .join(", ");
}

/** Light client-side check for page-range input before upload. */
export function isValidPageRangesInput(value) {
  const text = (value || "").trim();
  if (!text) return true;
  return /^(\d+(\s*-\s*\d+)?)(\s*,\s*\d+(\s*-\s*\d+)?)*$/.test(text);
}

/** Default number of RFP cards shown before expanding the library. */
export const LIBRARY_DEFAULT_VISIBLE = 5;

/** Existing RFP row: customer, country, owner, date, status, downloads. */
export const LIBRARY_ROW_GRID =
  "sm:grid sm:grid-cols-[minmax(0,1.4fr)_minmax(0,0.9fr)_minmax(0,1fr)_4.5rem_3.25rem_9.5rem] sm:items-center sm:gap-2";

/** Sort jobs by recency: updated_at, then created_at, then preserve order. */
export function sortLibraryJobsByRecency(jobs) {
  return [...(jobs || [])].sort((a, b) => {
    const aTime = Date.parse(a?.updated_at || a?.created_at || "") || 0;
    const bTime = Date.parse(b?.updated_at || b?.created_at || "") || 0;
    if (bTime !== aTime) return bTime - aTime;
    return (b?.job_id || "").localeCompare(a?.job_id || "");
  });
}

/** Filter RFP library jobs by customer search, owner SE, and country. */
export function filterLibraryJobs(jobs, { search = "", ownerSe = "", country = "" } = {}) {
  const q = search.trim().toLowerCase();
  return (jobs || []).filter((job) => {
    if (ownerSe && displayOwnerSe(job) !== ownerSe) return false;
    if (country && displayCountry(job) !== country) return false;
    if (!q) return true;
    // Primary search is customer name only (owner/country are separate filters).
    return displayCustomer(job).toLowerCase().includes(q);
  });
}

/** Unique owner SE values for filter dropdown. */
export function uniqueOwnerSes(jobs) {
  return [...new Set((jobs || []).map(displayOwnerSe))].sort((a, b) => {
    if (a === "Unassigned SE") return 1;
    if (b === "Unassigned SE") return -1;
    return a.localeCompare(b);
  });
}

/** Unique country values for filter dropdown (includes CALA for legacy jobs). */
export function uniqueCountries(jobs) {
  return [...new Set((jobs || []).map(displayCountry))].sort((a, b) => {
    if (a === RFP_COUNTRY_LEGACY_DEFAULT) return -1;
    if (b === RFP_COUNTRY_LEGACY_DEFAULT) return 1;
    return a.localeCompare(b);
  });
}

/** Compact date for library rows (e.g. Aug 3). */
export function formatUpdatedShort(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric" });
  } catch {
    return "—";
  }
}

/** Compact status glyph/label for library rows. */
export function compactJobStatus(job) {
  const status = (job?.status || "").toLowerCase();
  const phase = (job?.phase || "").toLowerCase();
  if (status === "failed" || phase === "failed") {
    return { kind: "failed", label: "Failed" };
  }
  if (status === "queued" || status === "processing" || phase === "processing") {
    return { kind: "processing", label: status === "queued" ? "Queued" : "Processing" };
  }
  if (phase === "needs_review" || job?.review_required) {
    return { kind: "review", label: "Compliance Review" };
  }
  if (status === "completed" || status === "reviewed" || phase === "reviewed" || phase === "extracted") {
    return { kind: "done", label: "✓" };
  }
  return { kind: "neutral", label: status || "—" };
}

export function computeWorkflowStep(jobMeta, { dirty = false, viewMode = "review" } = {}) {
  if (!jobMeta) return { key: "upload", index: 0 };
  const status = jobMeta.status;
  const phase = jobMeta.phase;
  if (status === "queued" || status === "processing" || phase === "processing") {
    return { key: "process", index: 1 };
  }
  if (phase === "needs_review" && jobMeta.review_required) {
    return { key: "outline", index: 1 };
  }
  if (status === "completed" && (jobMeta.row_count || 0) > 0) {
    if (viewMode === "analysis") return { key: "analysis", index: 2 };
    return { key: "review", index: 3 };
  }
  if (status === "failed") return { key: "process", index: 1 };
  return { key: "upload", index: 0 };
}

export const WORKFLOW_STEPS = [
  { key: "upload", label: "Upload" },
  { key: "process", label: "Process" },
  { key: "analysis", label: "Analysis" },
  { key: "review", label: "Compliance Review" },
];

const GRID_REQUIREMENT_VERBS =
  /(?:^|[^A-Za-zÁÉÍÓÚÜÑáéíóúüñ])(debe|deben|deberá|deberán|deverá|deverão|deverao|shall|must|se requiere)(?:[^A-Za-zÁÉÍÓÚÜÑáéíóúüñ]|$)/i;
const GRID_PROPONENTE_TEMPLATE = /resposta da proponente\s*:/i;
const GRID_CHAPTER_PREFIX = /^(ANEXO|CAP[IÍ]TULO|SECCI[ÓO]N|SEÇÃO|SECAO)\b/i;
const GRID_NUMBERED_HEADING = /^(\d{1,3}(?:\.\d{1,2}){0,4}\.?)\s*([A-ZÁÉÍÓÚÜÑÀÂÃÊÔÕ].*)$/;
const GRID_TITLE_GLUE = /\s+(?=Versão|Version|Data\b|Fecha|Descrição|Descripci)/i;

function _gridHeadingText(row) {
  return (row?.text || "").replace(/\s+/g, " ").trim().replace(/^[•\s]+/, "");
}

/** Numbered chapter / subsection title for grid grouping (not v2 section stamps). */
export function isGridSectionHeading(row) {
  const t = _gridHeadingText(row);
  if (!t || GRID_PROPONENTE_TEMPLATE.test(t)) return false;
  if (GRID_CHAPTER_PREFIX.test(t) && t.length <= 120) return true;
  const m = t.match(GRID_NUMBERED_HEADING);
  if (!m) return false;
  const titleOnly = m[2].split(GRID_TITLE_GLUE)[0].trim();
  const head = `${m[1]} ${titleOnly}`.trim();
  if (GRID_REQUIREMENT_VERBS.test(head)) return false;
  if (titleOnly.length > 120) return false;
  return true;
}

export function gridSectionHeadingTitle(row) {
  const t = _gridHeadingText(row);
  if (!t) return "Document";
  if (GRID_CHAPTER_PREFIX.test(t)) {
    return t.length > 80 ? t.slice(0, 80).trim() : t;
  }
  const m = t.match(GRID_NUMBERED_HEADING);
  if (!m) return t.length > 80 ? t.slice(0, 80).trim() : t;
  let rest = m[2].split(GRID_TITLE_GLUE)[0].trim();
  rest = rest.split(/\s+/).slice(0, 12).join(" ");
  if (rest.length > 80) rest = rest.slice(0, 80).trim();
  return `${m[1]} ${rest}`.replace(/\s+/g, " ").trim();
}

/** Contiguous document-order runs. New group on a heading; never bucket by section_id. */
export function groupRowsBySection(rows) {
  const groups = [];
  let current = null;
  (rows || []).forEach((row, idx) => {
    if (!current || isGridSectionHeading(row)) {
      const title = isGridSectionHeading(row) ? gridSectionHeadingTitle(row) : "Document";
      current = {
        key: `${idx}::${title}`,
        sectionId: row.section_id || "s1",
        title,
        rows: [],
      };
      groups.push(current);
    }
    current.rows.push(row);
  });
  return groups;
}

export function countDirtyRows(rows, baseline) {
  if (!baseline?.length) return 0;
  try {
    return JSON.stringify(rows) !== JSON.stringify(baseline) ? 1 : 0;
  } catch {
    return 0;
  }
}
